<template>

	<header class="header-wrapper header-layout1">
		<div class="header-top bg-title py-2 d-none d-md-block">
			<div class="container container-style1 py-1">
				<div v-if="selected_page !== '商城'" class="row justify-content-center justify-content-xl-between">
					<div class="col-auto d-none d-xl-block">
						<ul class="head-top-links text-end">
							<li v-if='phone=="false"'>
								<ul class="header-social">
									<li>
										<a href="#/pages/login">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>登陆
											</span>
										</a>
									</li>
									<li>
										<a href="#/home/register">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>注册
											</span>
										</a>
									</li>
								</ul>
							</li>
							<li v-if='phone=="false"'>
								<a href="#/home/forget">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>忘记密码？
									</span>
								</a>
							</li>
							<li v-if='phone!="false"'>
								<a href="#/user/notice" style="color:#07ccec;">
									<span>
										<el-badge v-if='message_qty>0' :value="message_qty" class="item">
											<i class="el-icon-chat-dot-round ro-round-icon"></i>
										</el-badge>

										<i v-else='' class="el-icon-chat-dot-round ro-round-icon"></i>
									</span>
								</a>
								<a style="color:#07ccec;">
									<el-dropdown trigger="click">
										<span class="el-dropdown-link" style="margin-left: 20px;">
											<i class="fal fa-user ro-round-icon"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<a href="#/user/notice">
												<el-dropdown-item>我的首页</el-dropdown-item>
											</a>
											<a href="#/user/order">
												<el-dropdown-item>我的订单</el-dropdown-item>
											</a>
											<a @click="log_out()">
												<el-dropdown-item>退出</el-dropdown-item>
											</a>
										</el-dropdown-menu>
									</el-dropdown>
								</a>
							</li>

						</ul>
					</div>
					<!-- <div class="col-auto d-none d-xl-block" v-if="user_id">
						<ul class="head-top-links text-end">
							
							<li>
								<a href="#/user/index">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>个人中心
									</span>
								</a>
							</li>
						</ul>
					</div> -->
				</div>
				<div v-if="selected_page == '商城'" class="row justify-content-center justify-content-xl-between">
					<div class="col-auto">
						<ul class="header-top-info list-unstyled m-0">
							<li>
								<a class="text-reset">您好！欢迎使用内蒙古健康教育与健康促进协会服务平台!</a>
							</li>
						</ul>
					</div>
					<div class="col-auto d-none d-xl-block">
						<ul class="head-top-links text-end">
							<li v-if='phone=="false"'>
								<ul class="header-social">
									<li>
										<a href="#/pages/login">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>登陆
											</span>
										</a>
									</li>
									<li>
										<a href="#/home/register">
											<span class="ro-header-btn">
												<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>注册
											</span>
										</a>
									</li>
								</ul>
							</li>
							<li v-if='phone=="false"'>
								<a href="#/home/forget">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>忘记密码？
									</span>
								</a>
							</li>
							<li v-if='phone!="false"'>

								<a href="#/user/notice" style="color:#07ccec;">
									<span>
										<el-badge :value="12" class="item">
											<i class="el-icon-chat-dot-round ro-round-icon"></i>
										</el-badge>
									</span>
								</a>

								<a style="color:#07ccec;">
									<el-dropdown trigger="click">
										<span class="el-dropdown-link" style="margin-left: 20px;">
											<i class="fal fa-user ro-round-icon"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<a href="#/user/notice">
												<el-dropdown-item>我的首页</el-dropdown-item>
											</a>
											<a href="#/user/order">
												<el-dropdown-item>我的订单</el-dropdown-item>
											</a>
											<a @click="log_out()">
												<el-dropdown-item>退出</el-dropdown-item>
											</a>
										</el-dropdown-menu>
									</el-dropdown>
								</a>
								<a style="color:#07ccec;">
									<el-dropdown trigger="click">
										<span
											style="margin-left: 20px;background: orange;padding:8px 20px;border-radius: 3px;color:white;font-weight: 800;">
											<i class="el-icon-shopping-cart-full" style="font-size: 20px;"></i>
											购物车(1)
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item v-for="(item,index) in 6"
												style="border-bottom: 1px solid #cdcdcd;overflow: hidden;padding:5px 20px;">
												<img src="../../static/picture/logo.jpeg"
													style="width: 80px;height:50px;float:left" />
												<div
													style="width: 80px;float:left;line-height: 50px;text-align: center;">
													商品名称</div>
												<div
													style="width: 80px;float:left;line-height: 50px;text-align: center;">
													29元X2</div>
											</el-dropdown-item>
											<div style="width: 100%;padding:5px 20px;">
												<span style="float: left;font-size: 12px;line-height: 20px;">
													<div>共3件商品</div>
													<div style="font-size:20px;color:orangered">500<span
															style="font-size:12px;">元</span></div>
												</span>
												<a href="#/shop/settlement">
													<el-button style="float: right;margin-top: 8px;" type="warning"
														size="small">去购物车结算</el-button>
												</a>
											</div>
										</el-dropdown-menu>
									</el-dropdown>
								</a>
							</li>

						</ul>
					</div>
					<!-- <div class="col-auto d-none d-xl-block" v-if="user_id">
						<ul class="head-top-links text-end">
							
							<li>
								<a href="#/user/index">
									<span class="ro-header-btn">
										<i class="fal fa-user" style="margin-right:5px;color:#07ccec;"></i>个人中心
									</span>
								</a>
							</li>
						</ul>
					</div> -->
				</div>
			</div>
		</div>
		<div class="sticky-wrap">
			<div class="sticky-active">
				<div class="header-main">
					<div class="container container-style1 position-relative">
						<div class="row align-items-center justify-content-between">
							<div class="col-auto">
								<div class="header1-logo py-2" style="line-height: 80px;">
									<a href="#/" style="color:#333">
										<div :style="{color:(selected_page !== '商城'?'white':'')}"
											style="margin-left: 20px;font-size: 23px;float: left;line-height: 70px;">
											<span :style="{background:(selected_page !== '商城'?'rgb(50, 204, 255)':'')}"
												style="padding:0 5px;">骐众数据检索系统</span>
										</div>
									</a>
<!-- 									<a href="https://shop.nmgkjcx.cn/#/" style="color:#333">
										<div style="margin-left: 20px;font-size: 23px;float: left;line-height: 70px;">
											<span style="padding:0 5px;">宣传栏</span>
										</div>
									</a> -->
									
									
								</div>
							</div>
							<div class="col text-end">
								<nav v-if="selected_page !== '商城'" class="main-menu menu-style1 d-none d-lg-block">
									<ul>
										<li>
											<a href="#/"
												:style="{color:(selected_page == '首页'?'rgb(50, 204, 255)':'')}">首页</a>
										</li>
										<li>
											<a href="#/pages/about_us"
												:style="{color:(selected_page == '关于我们'?'rgb(50, 204, 255)':'')}">关于我们</a>
										</li>
										<li>
											<a href="#/pages/yw"
												:style="{color:(selected_page == '业务介绍'?'rgb(50, 204, 255)':'')}">业务介绍</a>
										</li>
										<li>
											<a href="#/pages/sf"
												:style="{color:(selected_page == '收费标准'?'rgb(50, 204, 255)':'')}">收费标准</a>
										</li>
									</ul>
								</nav>
							</div>
							<div class="col-auto d-none-xxxl">

								<div class="header-call phone-box d-flex align-items-center style2">
									<!-- 未登录状态下 -->
									<a href="tel:xxxx" class="box-icon" v-if='phone=="false"'>
										<i class="fas fa-phone-alt"></i>
									</a>
									<div class="media-body" style="text-align: left;" v-if='phone=="false"'>
										<span class="fs-xs text-title">咨询电话</span>
									</div>
									<!-- 已登录状态下 -->
									<a href="#/user/notice" v-if='phone!="false"'>
										<div
											style="border:1px solid #07ccec;padding:5px 20px;color:#07ccec;border-radius: 5px;font-size: 12px;text-align: left;line-height: 15px;">
											个人中心<br />
											Presonal Center
										</div>
									</a>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>
<script>
	import {
		fetchGet,
		fetchPost
	} from "../../utils/request"
	import qs from 'qs'
	export default {
		name: "roheader",
		props: ['selected_page'],
		data: function() {
			return {
				message_qty:0,
				// user_id: localStorage.getItem('user_id'),
				// phone: localStorage.getItem('phone'),
			};
		},
		created:function(){
                    var session_id = window.localStorage.getItem('session_id')
	            console.log("session_id =", session_id, "Type:", typeof session_id);
		    if(session_id !== "false" && session_id !== "")
		    {
		        console.log("-----get_message_data---------")
			this.get_message_data()
		    }
		},
		computed: {
			phone: function() {
				console.log(localStorage.getItem('phone'))
				var phone = localStorage.getItem('phone')
				if (phone == null) {
					phone = 'false'
				}
				return phone
			},
			
		},
		methods: {
			get_message_data() {
				var data = {
					'id': localStorage.getItem('user_id'),
					'page': 1,
					'page_size': 100,
				}
				var self = this
				fetchPost('/ro/tec_search/notice/home_list/v1', data).then(response => {
					self.message_qty = response.data.message_qty
					// console.log(response.data)
					// if(response.data.update_message!='no_message'){
					// 	alert(response.data.update_message)
					// }
					if(response.data.result=='session_expired'){
											this.log_out()
										}
										
				})
			},
			log_out() {
				localStorage.setItem('phone', false)
				localStorage.setItem('user_id', false)
				localStorage.setItem('message_qty', false)
				localStorage.setItem('session_id', false)
				this.$router.push("/pages/login")
			}

		}
	};
</script>

<style>
	@import url("../../static/css/css2.css");
	@import url("../../static/css/app.min.css");
	@import url("../../static/css/fontawesome.min.css");
	@import url("../../static/css/animate.min.css");
	@import url("../../static/css/style.css");

	.ro-header-btn {
		font-size: 12px;
		text-align: center;
		padding: 3px 10px;
		border-radius: 5px;
		border: 1px solid white;
	}

	.ro-round-icon {
		margin-right: 5px;
		background-color: white;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		line-height: 25px;
		text-align: center;
	}

	.item {
		margin-top: 0px;
		margin-right: 20px;
	}

	.el-badge__content {
		border: none !important;
	}

	.el-badge__content.is-fixed {
		transform: translateY(-20%) translateX(90%);
	}
</style>
